import { useFormik } from "formik";
import { useEffect } from "react";
import { SketchEditor as View, Sketch } from "ui-components";

import {
	useSetActive,
	useSelectSketch,
	useUpdateSketch,
	useSetDrawingMode,
	useSetSketchGeojson,
	useSketchGeojson,
} from "~map-view/states/sketch";

export const SketchEditor = (props) => {
	const setSketchGeojson = useSetSketchGeojson();
	const sketchGeojson = useSketchGeojson();
	const setDrawingMode = useSetDrawingMode();
	const setActive = useSetActive();
	const selectSketch = useSelectSketch();
	const updateSketch = useUpdateSketch();

	const form = useFormik<Sketch>({
		initialValues: {
			title: "",
			description: "",
			editable: true,
			id: "",
		},
		onSubmit: (values, helpers) => {
			setDrawingMode("close");
			updateSketch({ ...values, geojson: JSON.stringify(sketchGeojson) });
			setActive("Sketches");
			setSketchGeojson(null);
			helpers.resetForm();
		},
	});

	// Update form values once selectSketch is available
	useEffect(() => {
		if (selectSketch && props.active === "edit-sketch") {
			void form.setValues({
				title: selectSketch?.title || "",
				description: selectSketch?.description || "",
				id: selectSketch?.id || "",
				editable: true,
			});
			if (selectSketch?.geojson && !sketchGeojson) {
				setSketchGeojson(JSON.parse(selectSketch?.geojson));
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectSketch, props.active]);

	const handleSketchModeChange = (mode) => {
		setDrawingMode(mode);
	};

	const handleCancel = () => {
		setDrawingMode("close");
		setActive("Sketches");
		setSketchGeojson(null);
	};

	if (props.active === "edit-sketch")
		return (
			<>
				<View
					onCancel={handleCancel}
					form={form}
					onSketchModeChange={handleSketchModeChange}
				/>
			</>
		);

	return null;
};
